import { StrictMode } from "react";

import { createRoot } from "react-dom/client";

import { App } from "@/app";

import "@/styles.css";

const root = document.getElementById("root");

// A missing root is a broken index.html, not a runtime condition worth
// handling — fail loudly rather than rendering into nothing.
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
